import { Step } from '@main/mobile-menu/const';
import { Action } from '@ngrx/store';
import { MobileMenuData } from '../mobile-menu-state';

export const MOBILE_MENU_NEXT_STEP = '[Main Layout] Mobile Menu Next Step';
export const MOBILE_MENU_SIMPLE_NEXT_STEP = '[Main Layout] Mobile Menu Simple Next Step';
export const MOBILE_MENU_PREV_STEP = '[Main Layout] Mobile Menu Prev Step';
export const MOBILE_MENU_RESET_STEPS = '[Main Layout] Mobile Menu Reset Steps';
export const MOBILE_MENU_SET_STATE = '[Main Layout] Mobile Menu Set State';

export class MobileMenuNextStep implements Action {
  readonly type = MOBILE_MENU_NEXT_STEP;

  constructor(public payload: Step) {}
}

export class MobileMenuSimpleForward implements Action {
  readonly type = MOBILE_MENU_SIMPLE_NEXT_STEP;
}

export class MobileMenuPrevStep implements Action {
  readonly type = MOBILE_MENU_PREV_STEP;
}

export class MobileMenuSetState implements Action {
  readonly type = MOBILE_MENU_SET_STATE;

  constructor(public payload: MobileMenuData) {}
}

export class MobileMenuResetSteps implements Action {
  readonly type = MOBILE_MENU_RESET_STEPS;
}
